<template>
  <div class="container">
    <EditDetailDialog
      :visible.sync="editDialogVisible"
      :is-edit="isEdit"
      :editRow="editRow"
      @close="onDialogClose"
    />
    <div class="title_container">
      <span class="title_text">{{$t('common.boxNo')}}:<span class="content_text">{{boxNo}}</span></span>
      <span class="title_text">{{$t('common.orderNo')}}:<span class="content_text">{{incoOrderNo}}</span></span>
      <span class="title_text">{{$t('common.lotNo')}}:<span class="content_text">{{lotNo}}</span></span>
      <span class="title_text">{{$t('common.status')}}:<span class="content_text">{{storeStatusVal(status)}}</span></span>
      <span class="title_text">{{$t('common.storePosition')}}:<span class="content_text">{{storePosition}}</span></span>
      <span class="title_text">{{$t('common.entryTime')}}:<span class="content_text">{{createTimeVal}}</span></span>
      <span class="title_text">{{$t('common.count')}}:<span class="content_text">{{count}}</span></span>
    </div>
    <div class="separator" style="margin-bottom: 10px;"></div>
    <div v-if="!isIncomingOrderFinished" class="control-container">
      <el-button type="warning" size="small" @click="addBox">
        {{$t('common.newlyAdded')}}
      </el-button>
    </div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column prop="trackingNo" :label="$t('common.caseNo')"/>
        <el-table-column prop="lotNo" :label="$t('common.lotNo')"/>
        <el-table-column prop="count" :label="$t('common.count')"/>
        <el-table-column :label="$t('common.status')" width="120">
          <template slot-scope="scope">
            {{storeStatusVal(scope.row.status)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('incomeStorage.updateAt')">
          <template slot-scope="scope">
            {{formatDate(scope.row.updateAt)}}
          </template>
        </el-table-column>
        <el-table-column v-if="!isIncomingOrderFinished" :label="$t('common.operate')">
          <template slot-scope="scope" v-if="isNotDelivery(scope.row)">
            <el-button type="text" class="link" @click="editCase(scope.row)">
              {{$t('common.edit')}}
            </el-button>
            <span class="vertical-separator"/>
            <el-button type="text" class="link" @click="deleteCase(scope.row)">
              {{$t('common.delete')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {
  incoStorageDetailById,
  incoStorageDelCase,
} from '@/api/incoStorage';
import EditDetailDialog from './components/EditDetailDialog';
import { storeStatus } from '@/utils/defines';

export default {
  name: 'detail',
  components: {
    EditDetailDialog,
  },
  data() {
    const storeStatusObj = {};
    let storeStatueItem;
    for (const key in storeStatus) {
      if (Object.prototype.hasOwnProperty.call(storeStatus, key)) {
        storeStatueItem = storeStatus[key];
        storeStatusObj[storeStatueItem.val] = storeStatueItem.explain;
      }
    }
    return {
      listData: [],
      id: undefined,
      incoOrderNo: '',
      boxNo: '',
      storePosition: '',
      lotNo: undefined,
      status: undefined,
      createAt: '',
      count: undefined,
      editDialogVisible: false,
      isEdit: false,
      editRow: {},
      storeStatus,
      storeStatusObj,
    };
  },
  mounted() {
    this.id = this.$route.params && this.$route.params.id;
    this.incoStorageDetailById();
  },
  computed: {
    displayData() {
      return this.listData;
    },
    isIncomingOrderFinished() {
      return this.status === storeStatus.delivery.val;
    },
    createTimeVal() {
      const date = this.createAt;
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD HH:mm:ss');
      }
      return updateDate.local().format('YYYY/MM/DD HH:mm:ss');
    },
  },
  methods: {
    async incoStorageDetailById() {
      try {
        const { id } = this;
        const res = await incoStorageDetailById({
          id,
        });
        const data = res.data.record;
        const {
          incoOrder,
          boxNo,
          storePosition,
          lotNo,
          status,
          createAt,
          count,
          incoStoreDetails,
        } = data;
        this.incoOrderNo = incoOrder && incoOrder.incoOrderNo || '';
        this.boxNo = boxNo;
        this.storePosition =storePosition;
        this.lotNo = lotNo;
        this.status = status;
        this.createAt = createAt;
        this.count = count;
        this.listData = incoStoreDetails;
      } catch (e) {
        // do nothing.
      }
    },
    addBox() {
      const {
        boxNo,
      } = this;
      if (!boxNo) {
        return;
      }
      this.isEdit = false;
      this.editRow = {
        boxNo,
        cases: [{
          trackingNo: undefined,
          count: undefined,
        }]
      };
      this.editDialogVisible = true;
    },
    editCase(row) {
      const {
        boxNo,
      } = this;
      const {
        trackingNo,
        count,
      } = row;
      this.isEdit = true;
      this.editRow = {
        boxNo,
        cases: [{
          trackingNo,
          count,
        }]
      };
      this.editDialogVisible = true;
    },
    async deleteCase(row) {
      this.$confirm(this.$t('incomeStorage.thisActionWillDeleteTheCase'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        const {
          trackingNo
        } = row;
        try {
          await incoStorageDelCase({
            trackingNo,
          });
          this.$message({
            type: 'success',
            message: this.$t('incomeStorage.deleteSuccess'),
          });
          this.incoStorageDetailById();
        } catch (e) {
          // do nothing.
        }
      }).catch(() => {
        // do nothing.
      });
    },
    onDialogClose() {
      this.incoStorageDetailById();
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      const isSameYear = updateDate.local().format('YYYY') === moment.utc().local().format('YYYY');
      if (isSameYear) {
        return updateDate.local().format('MM/DD');
      }
      return updateDate.local().format('YYYY/MM/DD');
    },
    storeStatusVal(val) {
      return this.storeStatusObj[`${val}`];
    },
    isNotDelivery(row) {
      return row.status !== storeStatus.delivery.val;
    },
  },
};
</script>

<style scoped>
  .container {
    height: 100%;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
  }
  .separator {
    width: 100%;
    height: 1px;
    background: #E5E5E5;
    display: block;
  }
  .title_container {
    padding: 20px 30px;
    box-sizing: border-box;
    display: inline-block;
  }
  .title_text {
    font-size: 14px;
    color: #555555;
    margin-right: 50px;
  }
  .content_text {
    margin-left: 10px;
  }
  .control-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    margin: 0 20px 10px;
  }
  .target-container {
    flex: 1;
    display: -webkit-flex;
    display: flex;
    margin: 0 20px 20px;
    height: 100%;
    overflow: auto;
  }
  .link {
    color: #169BD5;
    padding: 0 5px;
  }
  .vertical-separator {
    display: inline-block;
    width: 1px;
    height: 12px;
    margin: 0 13px;
    vertical-align: middle;
    background: #e8e8e8;
  }
</style>
<style>
  .headerCellName {
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
  }
</style>
